import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';


import {AppComponent} from './app.component';
import {ChatComponent} from './components/chat/chat.component';
import {DrawingSectionComponent} from './components/drawing-section/drawing-section.component';
import {DialogflowService} from './services/dialogflow.service';
import {HttpClientModule} from '@angular/common/http';
import {SharedDataService} from './services/shared-data.service';
import {FormsModule} from '@angular/forms';


@NgModule({
  declarations: [
    AppComponent,
    ChatComponent,
    DrawingSectionComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule
  ],
  providers: [DialogflowService, SharedDataService],
  bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts